// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"27":"cf782091","64":"619bd4cd","83":"518e82f2","216":"057d6890","223":"11f836ac","247":"d07cbf68","272":"fe3c466b","453":"1834358c","507":"ad21049a","609":"3c07370d","627":"aaa70853","808":"6e05dab6","893":"60f7ddc6","917":"b4d7a254"}[chunkId] + ".chunk.js";
};